/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActiveTariffPlanDto } from '../../models/backend-active-tariff-plan-dto';

export interface SubscriptionTariffPlanActiveRetrieve$Params {}

export function subscriptionTariffPlanActiveRetrieve(
  http: HttpClient,
  rootUrl: string,
  params?: SubscriptionTariffPlanActiveRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActiveTariffPlanDto>> {
  const rb = new RequestBuilder(rootUrl, subscriptionTariffPlanActiveRetrieve.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActiveTariffPlanDto>;
    }),
  );
}

subscriptionTariffPlanActiveRetrieve.PATH = '/api/subscription/tariff_plan/active/';
